import React, { forwardRef } from "react"

import { DropdownButtonProps, dropdownProps } from "./DropdownButton"
import { IconButton, IconButtonProps } from "./IconButton"

/**
 * An icon-only button that toggles a dropdown menu or popover. Appends a
 * caret suffix to the icon and wires up `aria-controls` and `aria-expanded`
 * to the controlled element. Requires an `aria-label` for accessibility.
 *
 * @component
 * @see {@link https://planningcenter.github.io/tapestry/?path=/docs/components-button-dropdown-icon-button--docs | Storybook Documentation}
 */
export const DropdownIconButton = forwardRef<
  HTMLButtonElement,
  IconButtonProps & DropdownButtonProps
>((props, ref) => {
  return <IconButton ref={ref} {...props} {...dropdownProps(props)} />
})

DropdownIconButton.displayName = "DropdownIconButton"
